import {FC} from 'react'

interface TooltipContentProps {
  message: string
}
export const TooltipContent: FC<TooltipContentProps> = ({message}) => (
  <div className="bg-gray-800 text-xs abc-regular px-2 py-1 rounded-md overflow-hidden max-w-sm text-center shadow-lg">
    {message}
  </div>
)
